module.exports = __webpack_public_path__ + "static/media/profile-press-ad@2x.86121f33.png";